import { setBodyScrollability } from "@lib/setBodyScrollability";
import classNames from "classnames";
import * as React from "react";
import { IconButton } from "./IconButton";

export interface ModalProps {
  onClose: () => void;
  isOpen: boolean;
  children: React.ReactNode;
}

export const Modal: React.FC<ModalProps> = ({ children, onClose, isOpen }) => {
  React.useEffect(() => {
    setBodyScrollability(!isOpen);
    return () => setBodyScrollability(true);
  }, [isOpen]);

  return (
    <div
      className={classNames("modal", isOpen && "modal--open")}
      // setting inline style to avoid modal content to flash unstyled before stylesheet is loaded
      style={{ opacity: 0 }}
    >
      <div role="presentation" className={"modal--content"}>
        {children}

        <IconButton
          icon="close"
          onClick={onClose}
          title="Close modal"
          className="modal--close-button"
        />
      </div>
    </div>
  );
};

interface ModalBodyProps {
  tall?: boolean;
  noPadding?: boolean;
  children: React.ReactNode;
}
export const ModalBody: React.FC<ModalBodyProps> = ({
  children,
  tall,
  noPadding,
}) => (
  <div
    className={classNames(
      "modal-body",
      noPadding && "modal-body--no-padding",
      tall && "modal-body--tall",
    )}
  >
    {children}
  </div>
);
;
import "/Users/jekri/.yarn/berry/cache/@sentry-bundler-plugin-core-npm-0.7.2-054e3436fd-10c0.zip/node_modules/@sentry/bundler-plugin-core/sentry-release-injection-file.js";